// Maps the CRM's granular workflow states into the 4 simplified headline stages.
export const MAIN_STAGES = ['Qualification', 'Counselling', 'Registration', 'Documentation'];

const STAGE_INDEX = {
  qualification: 0,
  appointment_pending: 0,
  counselling_scheduled: 1,
  counselling_due: 1,
  conversion_follow_up: 2,
  future: 2,
  registered: 2,
  admission: 3,
};

// Returns { key, label, index }. index -1 means Closed.
export function getMainStage(student) {
  if (!student) return { key: 'qualification', label: 'Qualification', index: 0 };
  if (student.is_converted) return { key: 'documentation', label: 'Documentation', index: 3 };
  const ws = student.workflow_stage;
  if (ws === 'closed') return { key: 'closed', label: 'Closed', index: -1 };
  let idx = STAGE_INDEX[ws];
  if (idx === undefined) idx = 0; // legacy / not-yet-in-workflow leads
  return { key: MAIN_STAGES[idx].toLowerCase(), label: MAIN_STAGES[idx], index: idx };
}
